import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/colors.css';
import './styles/constants.css';
import './index.css';
import AuthRoutes from './routes/AuthRoutes';
import AccountRoutes from './routes/AccountRoutes';
import AuthProvider from './providers/AuthProvider';
import NotAuthProvider from './providers/NotAuthProvider';
import CourseRoutes from './routes/CourseRoutes';
import { useTheme } from '@mui/material/styles';
import ExamRoutes from './routes/ExamRoutes';
import QuestionRoutes from './routes/QuestionRoutes';
import OptionRoutes from './routes/OptionRoutes';
import FileRoutes from './routes/FileRoutes';
import PathRoutes from './routes/PathRoutes';
import DashboardRoutes from './routes/DashboardRoutes';
import StudentsRoutes from './routes/StudentsRoutes';
import FinancialRoutes from './routes/FinancialRoutes';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { SidebarDrawerProvider } from './context/SidebarDrawerContext';

function AppShell({ children, fullWidth = false }) {
  return (
    <AuthProvider role="teacher">
      <SidebarDrawerProvider>
        <Header isFullWidth={fullWidth} />
        {!fullWidth && <Sidebar />}
        {children}
      </SidebarDrawerProvider>
    </AuthProvider>
  );
}

const routerBasename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

function App() {
  const theme = useTheme();

  return (
    <main>
      <div className="App" style={{ backgroundColor: theme.palette.background.default }}>
        <BrowserRouter basename={routerBasename}>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" />} />
            {
              AuthRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<NotAuthProvider>{route.element}</NotAuthProvider>} />
              )
            }
            {
              DashboardRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              StudentsRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              FinancialRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              AccountRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              CourseRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              ExamRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              QuestionRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              OptionRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              FileRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
            {
              PathRoutes().map((route, index) =>
                <Route key={index} path={route.path} element={<AppShell>{route.element}</AppShell>} />
              )
            }
          </Routes>
        </BrowserRouter>
      </div>
    </main>
  );
}

export default App;
